import { render, staticRenderFns } from "./opensearch.vue?vue&type=template&id=0141a690&"
import script from "./opensearch.vue?vue&type=script&lang=js&"
export * from "./opensearch.vue?vue&type=script&lang=js&"
import style0 from "./opensearch.vue?vue&type=style&index=0&id=0141a690&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports